import React, { useEffect, useState } from 'react'
import CommonTable from '../../common/Table/CommonTable'
import { useFormik } from 'formik';
import { addOrUpdateBonus, bonusCityAndCountryListApi, bonusListApi, cityByCountryApi, countryListApi, enableOrDisableBonusApi, getAdminConfigurationApi, updateAdminConfigurationsApi, updateBonusStatus, updateBonusWithdrawalLimitApi } from '../../../utils/ApiEndpointFunctions';
import ReactSelect from 'react-select';
import MinimumRideChargesForBonusModal from '../../common/Modal/MinimumRideChargesForBonusModal';
import { bonusInitialValue, bonusValidationSchema, bonusWithdrawalLimitValidationSchema, minimumChargesBonusInitialValue, minimumChargesBonusInitialValueSchema } from '../../common/Validation';
import { capitalizeWords, convertTimeTo12HrFormat } from '../../../utils/HelperFuncitons';
import toast from 'react-hot-toast';
import AddBonusFormModal from '../../common/Modal/AddBonusFormModal';
import DeletedModal from '../../common/Modal/DeletedModal';
import { useAdminContext } from '../../../context/adminContext';
import { useSearchParams } from 'react-router-dom';


function Bonus({ bonusType }) {
  const [minChargesLoader, setMinChargesLoader] = useState(false);
  const [countryOptions, setCountryOptions] = useState([])
  const [cityOptions, setCityOptions] = useState([])
  const InputWithButtonModalId = "InputWithButtonModalId"
  const BonusModalId = "BonusModalId";
   const [editWithdrawalId, setEditWithdrawalId] = useState(null); // for editing row
  const [editableWithdrawal, setEditableWithdrawal] = useState("");
  const [withdrawalLoadingId, setWithdrawalLoadingId] = useState(null); // row-level locking

  const WithdrawalLimitModalId = "WithdrawalLimitModal";

  const [tableData, setTableData] = useState([]);
  const [bonusCitytableData, setBonusCitytableDat] = useState([]);
  const [loader, setLoader] = useState(true);
  const [statusLoading, setStatusLoading] = useState(false)
  const [addLoader, setAddLoader] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [bonusTableLoader, setBonusTableLoader] = useState(false);
  const { adminDetail } = useAdminContext();

  const [searchParams] = useSearchParams();
  const [type,setType]=useState("")
  const tab = searchParams.get("tab");
  const formattedTab = tab
    ? tab
      .split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ")
    : "";

    useEffect(()=>{
       setType(tab.split("-")[0])
    },[tab])

  const filterCites = async (countryId) => {
    try {
      const res = await cityByCountryApi("", countryId)
      if (res.status === 200) {
        let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
        setCityOptions(cityOption);
      }

    } catch (error) {
      console.log(error)
    }
  };

  const filterCountry = async (inputValue) => {
    try {
      const res = await countryListApi(inputValue)
      if (res.status === 200) {
        let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
        setCountryOptions(cityOption);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const getBonusList = async (countryId, cityId) => {
    try {
      setBonusTableLoader(true)
      const res = await bonusListApi(countryId, cityId, bonusType)
      if (res.status === 200) {
        setTableData(res.data?.BonusList)
      }
    } catch (error) {
      console.log(error)
    }
    setBonusTableLoader(false)
  }

  const selectBonusHandler = (ele) => {
    getBonusList(ele.countryId, ele.cityId)
  }

  const getBonusCityAndCountry = async () => {
    try {
      setLoader(true)
      const res = await bonusCityAndCountryListApi(searchFormik.values.countryId?.value, searchFormik.values.cityId?.value, bonusType)
      if (res.status === 200) {
        // console.log(res.data?.data)
        setBonusCitytableDat(res.data?.data)
      }
    } catch (error) {
      console.log(error)
    }
    setLoader(false)
  }

  const deleteModalId = "bonusDeleteModal"
  const deleteBonus = async () => {
    setAddLoader(true)
    try {
      const res = await updateBonusStatus({ id: selectedId.id, status: false })
      if (res.status === 200) {
        document.getElementById(deleteModalId).click();
        toast.success(capitalizeWords(res.data?.message))
        getBonusList(selectedId.countryId, selectedId.cityId);
      }
    } catch (error) {
      console.log(error)
      error.response ?
        toast.error(error.response?.data?.message) :
        toast.error("Something went wrong");
    }
    setAddLoader(false)
  }

  const updatingValueHandler = (value) => {
    console.log("modal opennnnnnnn", value)
    if (value?.duration) {
      value.duration = {
        label: capitalizeWords(value?.duration),
        value: value?.duration
      };
    }
    if (!value?.from || !value?.to) {
      value.from = ""
      value.to = ""
    }
    const updateObj = { ...value, cityId: { label: value.cityName, value: value.cityId }, countryId: { label: value.countryName, value: value.countryId } }
    formik.setValues(updateObj);
  };

  // const updatingWithdrawalValueHandler = (value) => {
  //   console.log("modal open", value)

  //   const updateObj = { ...value, cityId: { label: value.cityName, value: value.cityId }, countryId: { label: value.countryName, value: value.countryId } }
  //   WithdrawalFormik.setValues(updateObj);
  // };

  const handleEnableOrDisableBonus = async (value, index) => {
    try {
      setStatusLoading(true)
      const res = await enableOrDisableBonusApi({ id: value.id, status: !Boolean(tableData[index].isEnabled) })
      if (res.status === 200) {
        toast.success(res.data.message)
        tableData[index].isEnabled = !Boolean(tableData[index].isEnabled)
        setTableData(tableData)
      }
    } catch (err) {
      console.log(err)
      toast.error("Something Went Wrong")
    }
    setStatusLoading(false)
  }


  const submitMinRideCharges = async (value) => {
    try {
      setMinChargesLoader(true)

      const res = await updateAdminConfigurationsApi(value)
      if (res.status === 200) {
        toast.success(capitalizeWords(res.data?.message))
        document.getElementById(InputWithButtonModalId).click();
        getBonusCityAndCountry();
      }
    } catch (error) {
      console.log(error);
    }
    setMinChargesLoader(false)
  }

  const minimumChargesFormik = useFormik({
    initialValues: minimumChargesBonusInitialValue,
    onSubmit: submitMinRideCharges,
    validationSchema: minimumChargesBonusInitialValueSchema
  })

  // console.log(minimumChargesFormik.values)
  const handleSubmit = async (values) => {
    try {
      let payload = JSON.parse(JSON.stringify(values));
      setAddLoader(true)
      payload['duration'] = payload.duration.value
      payload.countryId = payload?.countryId?.value;
      // payload.cityId = payload?.cityId?.value;
      payload.cityId = payload.cityId?.map(c => c.value) || [];

      console.log(payload);

      const res = await addOrUpdateBonus(payload)
      if (res.status === 200) {
        toast.success(capitalizeWords(res.data?.message))
        getBonusList(payload.countryId, payload.cityId);
        getBonusCityAndCountry();
        document.getElementById(BonusModalId).click();
        formik.resetForm();
      }

    } catch (error) {
      console.log(error);
      error.response ?
        toast.error(error.response?.data?.message) :
        toast.error("Something went wrong");
    }
    setAddLoader(false)
  }

  const formik = useFormik({
    initialValues: { ...bonusInitialValue, countryId: adminDetail.role !== "superAdmin" && adminDetail.countryId ? { label: adminDetail.countryName, value: adminDetail.countryId } : null, 
 cityId: Array.isArray(bonusInitialValue.cityId)
  ? bonusInitialValue.cityId.map(id => ({ label: id.name, value: id.id }))
  : null,
  },
    onSubmit: handleSubmit,
    validationSchema: bonusValidationSchema
  })


  // const getMinCharges = async () => {
  //   try {
  //     const res = await getAdminConfigurationApi()
  //     if (res.status === 200) {
  //       minimumChargesFormik.setFieldValue("amount", res.data?.data?.minRideChargesForBonus)
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  const handleCityChange = (city) => {
    searchFormik.setFieldValue('cityId', city)
  }

  const handleCountryChange = (country) => {
    console.log(country, 'this is count')
    setCityOptions([])
    searchFormik.setFieldValue('countryId', country);
    searchFormik.setFieldValue('cityId', null);
    filterCites(country.value)
  }

  const searchFormik = useFormik({
    initialValues: {
      countryId: adminDetail.role !== "superAdmin" && adminDetail.countryId ? { label: adminDetail.countryName, value: adminDetail.countryId } : null,
      cityId: null,
    },
  })

  useEffect(() => {
    if (adminDetail?.countryId) {
      filterCites(adminDetail.countryId);
    }

    if (adminDetail?.role === "superAdmin") {
      filterCountry();
    }
  }, [adminDetail]);

  useEffect(() => {
    getBonusCityAndCountry();
  }, [searchFormik.values, bonusType])

  console.log("formik", formik?.errors);


  const bonusHeaderData = [
    { name: "S.No", className: "col-1", key: "index" },
    { name: "Name", className: "col-2", key: "name" },
    { name: "For", className: "col-2", key: "bonusFor" },
    { name: "No Of Trips", className: "col-1", key: "noOfTrips" },
    { name: "Duration", className: "col-1", key: "duration" },
    ...(bonusType != 'user' ? [{ name: "From", className: "col-1", key: "from" },
    { name: "To", className: "col-1", key: "to" },] : []),
    ...(bonusType != 'user' ? [{ name: "Minimum Rating", className: "col-1", key: "minRating" }] : []),
    { name: "Minimum Charges", className: "col-1", key: "minimumCharges" },
    { name: "Amount", className: "col-1", key: "amount" },
    // { name: "Min ride charge", className: "col-1", key: "minRideCharge" },
    { name: "Enable", className: "col-1", key: "isEnabled" },
    { name: "", className: "col-1", key: "action" }
  ];

  const bonusTableRowData = tableData.map((ele, index) => ({
    index: index + 1,
    name: ele?.name || "-",
    bonusFor: ele?.bonusFor || "-",
    noOfTrips: ele?.noOfTrips || "-",
    duration: ele?.duration && typeof ele.duration === "object" ? (ele?.duration?.label) : ele?.duration ? capitalizeWords(ele.duration) : "",
    ...(bonusType != 'user' ? {
      from: ele?.from ? convertTimeTo12HrFormat(ele?.from) : "-",
      to: ele?.to ? convertTimeTo12HrFormat(ele?.to) : "-"
    } : {}),
    ...(bonusType != 'user' ? { minRating: ele?.minimumRating ?? "-" } : {}),
    minimumCharges: ele?.minimumCharges ?? "-",
    amount: ele?.amount ?? "-",
    // minRideCharge: ele?.minRideChargesForBonus ?? "-",
    isEnabled: (
      <div className="form-check form-switch ">
        <input className="form-check-input" type="checkbox" checked={ele?.isEnabled} disabled={statusLoading} role="switch" id="flexSwitchCheckDefault" onChange={() => handleEnableOrDisableBonus(ele, index)} />
      </div>
    ),
    action: (<div className="dropdown">
      <button
        className=" border-0 bg-white"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-three-dots-vertical"
          viewBox="0 0 16 16"
        >
          <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
        </svg>
      </button>
      <ul
        className="dropdown-menu"
        style={{ zIndex: "1000" }}
      >
        <li className="dropdown-item">
          <div
            data-bs-toggle="modal"
            data-bs-target={`#${BonusModalId}`}
            onClick={() => { updatingValueHandler(ele) }}
            style={{ cursor: "pointer" }}
          >
            Edit
          </div>
        </li>

        <li className="dropdown-item" >
          <div
            data-bs-toggle="modal"
            data-bs-target={`#${deleteModalId}`}
            onClick={() => { setSelectedId({ id: ele?.id, countryId: ele.countryId, cityId: ele.cityId }) }}
            style={{ cursor: "pointer" }}
          >
            Delete
          </div>
        </li>
      </ul>
    </div>)
  }))

    // Edit handler
  const handleWithdrawalLimitEdit = (rowId, currentWithdrawal) => {
    // console.log("rowwwwwwww",rowId)
    setEditWithdrawalId(rowId);
    setEditableWithdrawal(currentWithdrawal ?? "");
  };

  // Update handler
  const handleWithdrawalLimitUpdate = async (rowId,ele) => {
    if (!editableWithdrawal || isNaN(editableWithdrawal)) {
      toast.error("Please enter a valid withdrawal limit");
      return;
    }

    try {
      setWithdrawalLoadingId(rowId); 
      const payload = {...ele, withdrawalLimit:editableWithdrawal,type}

      console.log("payload",payload)

      const res = await updateBonusWithdrawalLimitApi(payload);
      if (res.status === 200) {
        toast.success("Withdrawal limit updated");
        // getAllBonusCountries();
        getBonusCityAndCountry();
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to update withdrawal limit");
    } finally {
      setWithdrawalLoadingId(null); // unlock row
      setEditWithdrawalId(null);
      setEditableWithdrawal("");
    }
  };

  const bonusCountryHeaderData = [
    { name: "S.No.", className: "col", key: "index" },
    { name: "Country", className: "col", key: "countryName" },
    { name: "City", className: "col", key: "cityName" },
    { name: "Bonus count", className: "col", key: "bonusCount" },
    type==="user" && { name: "Withdrawal Limit", className: "col", key: "withdrawalLimit" },
    // { name: "Action", className: "col", key: "action" },
    // { name: "Min ride charge", className: "col", key: "minRideChargesForBonus" },
  ]

  useEffect(() => {
    console.log("tb data", bonusCitytableData)
  }, [bonusCitytableData])


  const bonusCountryRowData = bonusCitytableData.map((ele, index) => {
    return {
      index: index + 1,
      countryName: <div style={{ cursor: "pointer" }} className='text-primary' data-bs-toggle="offcanvas" data-bs-target="#offcanvasRightCites" onClick={() => { selectBonusHandler(ele) }}>{ele?.countryName}</div>,
      cityName: ele?.cityName || "-",
      bonusCount: ele?.bonusCount || "-",
      // withdrawalLimit: ele?.withdrawalLimit ,
         withdrawalLimit: editWithdrawalId === index ? (
      <div className="d-flex align-items-center gap-1">
        <input
          type="number"
          value={editableWithdrawal}
          onChange={(e) => setEditableWithdrawal(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleWithdrawalLimitUpdate(index,ele);
          }}
          disabled={withdrawalLoadingId === index}
          style={{ width: "80px" }}
          className="form-control form-control-sm"
        />
        <i
          className={`bi bi-check-lg ${withdrawalLoadingId === index ? "text-muted" : "text-success"}`}
          style={{
            cursor: withdrawalLoadingId === index ? "not-allowed" : "pointer",
            fontSize: "1.2rem",
            pointerEvents: withdrawalLoadingId === index ? "none" : "auto",
          }}
          onClick={() => handleWithdrawalLimitUpdate(index,ele)}
          title="Save withdrawal limit"
        ></i>
      </div>
    ) : (
      <>
        {ele?.withdrawalLimit ?? "-"}
        <i
          className="bi bi-pencil ms-2"
          style={{ cursor: "pointer" }}
          onClick={() => handleWithdrawalLimitEdit(index, ele?.withdrawalLimit,)}
          title="Edit withdrawal limit"
        ></i>
      </>
    ),
      // action: (<div className="dropdown">
      //   <button
      //     className=" border-0 bg-white"
      //     type="button"
      //     data-bs-toggle="dropdown"
      //     aria-expanded="false"
      //   >
      //     <svg
      //       xmlns="http://www.w3.org/2000/svg"
      //       width="16"
      //       height="16"
      //       fill="currentColor"
      //       className="bi bi-three-dots-vertical"
      //       viewBox="0 0 16 16"
      //     >
      //       <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
      //     </svg>
      //   </button>
      //   <ul
      //     className="dropdown-menu"
      //     style={{ zIndex: "1000" }}
      //   >
      //     <li className="dropdown-item">
      //       <div
      //         data-bs-toggle="modal"
      //         data-bs-target={`#${WithdrawalLimitModalId}`}
      //         onClick={() => { updatingWithdrawalValueHandler(ele) }}
      //         style={{ cursor: "pointer" }}
      //       >
      //         Edit
      //       </div>
      //     </li>
      //   </ul>
      // </div>)
      // minRideChargesForBonus: <div style={{ cursor: "pointer" }} className='text-primary' data-bs-toggle="modal" data-bs-target={`#${InputWithButtonModalId}`} onClick={() => { selectBonusHandler(ele); minimumChargesFormik.setValues({ minRideChargesForBonus: ele?.minRideChargesForBonus, cityId: ele?.cityId }) }}>{ele?.minRideChargesForBonus || "-"}</div>, 
    }
  })

  const handleUpdateWithdrawalLimit = async (values) => {
    try {
      console.log("withdrawal", values)
    } catch (error) {
      console.log("error message", error.message)
    }
  }

  const WithdrawalFormik = useFormik({
    initialValues: { type: "", withdrawalLimit: 0, countryId: adminDetail.role !== "superAdmin" && adminDetail.countryId ? { label: adminDetail.countryName, value: adminDetail.countryId } : null, },
    validationSchema: bonusWithdrawalLimitValidationSchema,
    onSubmit: handleUpdateWithdrawalLimit,
    enableReinitialize: true
  })

  return (
    <>

      <div className='card'>
        <div className="card-header">
          <div className="d-flex justify-content-between flex-wrap align-items-center mt-3 mt-lg-0">
            <h1>Bonus</h1>
            <div style={{ display: "-webkit-inline-box" }}>
              <div className="d-flex gap-2 justify-content-end align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <label htmlFor="city" className="form-label">Country</label>
                  <ReactSelect className='reactSelectMinWidth' isDisabled={adminDetail.role !== "superAdmin"} options={countryOptions} value={searchFormik?.values?.countryId} onChange={handleCountryChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Countries Available'} />
                  {searchFormik?.touched?.countryId && searchFormik?.errors?.countryId ? (<div className='req-error'>{searchFormik?.errors?.countryId}</div>) : null}
                </div>

                <div className="d-flex align-items-center gap-2">
                  <label htmlFor="city" className="form-label">City</label>
                  <ReactSelect className='reactSelectMinWidth' options={cityOptions} isDisabled={!searchFormik?.values?.countryId} value={searchFormik?.values?.cityId} onChange={handleCityChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Cities Available'} />
                  {searchFormik?.touched?.cityId && searchFormik?.errors?.cityId ? (<div className='req-error'>{searchFormik?.errors?.cityId}</div>) : null}
                </div>
                <div>
                  <div>
                    <button
                      className="btn btn-primary"
                      onClick={() => { searchFormik.resetForm(); }}
                      disabled={!searchFormik?.values?.countryId}
                    >
                      Reset filter
                    </button>
                  </div>
                </div>
                {/* <button
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target={`#${InputWithButtonModalId}`}
                  >
                    Minimum Ride Charges
                  </button> */}
                <button
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target={`#${BonusModalId}`}
                  onClick={() => {
                    formik.resetForm();
                    if (bonusType == 'user') {
                      formik.setFieldValue("bonusFor", 'user')
                      formik.setFieldValue("minimumRating", 0)
                    }
                  }}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
        <div className="card-body">
          <CommonTable headers={bonusCountryHeaderData} data={bonusCountryRowData} loading={loader} />
        </div>
      </div>

      <div className="offcanvas offcanvas-end" style={{ width: "50%" }} tabIndex="-1" id="offcanvasRightCites" aria-labelledby="offcanvasRightLabel">
        <div className="offcanvas-header">
          <h1 id="offcanvasRightLabel">Bonus</h1>
          <button type="button" className="btn-close text-reset" id={"offcanvasCity"} data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body">
          <div className="card-body">
            <CommonTable headers={bonusHeaderData} data={bonusTableRowData} loading={bonusTableLoader} />
          </div>
        </div>
      </div>

      <MinimumRideChargesForBonusModal
        modalId={InputWithButtonModalId}
        formik={minimumChargesFormik}
        loader={minChargesLoader}
      />

      <AddBonusFormModal modalId={BonusModalId} tabName={formattedTab} addLoader={addLoader} formik={formik} countryOptions={countryOptions} bonusType={bonusType}  />
      <DeletedModal
        modalId={deleteModalId}
        message={"this Bonus"}
        deletedHandler={deleteBonus}
        loader={addLoader}
      />

      {/* <CountryAndCityModal type={"City"} modalId={countryOrCiteModal} formik={formik} loader={addCityModal} selectedCountry={selectCountry} />
      <DeletedModal
        modalId={deleteModalId}
        message={"This city"}
        deletedHandler={removeCityHandler}
        loader={addCityModal}
      /> */}
    </>)
}

export default Bonus